import './multirangeslider.css';
import { Outlet } from 'react-router-dom';
import TopNav from './Components/Navigation/TopNav';
import SideNav from './Components/Navigation/SideNav';
import { useAppDispatch, useAppSelector } from './Reducers/store';
import {
  fetchCategories,
  fetchEquipmentSearchData,
  fetchSubCategories,
} from './Actions/CommonFields';
import { useEffect, useState } from 'react';
import Footer from './Components/Navigation/Footer';
import { UserLevelNames } from './Models/UserLevel';
import Loader from './Components/Common/Loader';

function App() {
  const dispatch = useAppDispatch();
  const { userModel } = useAppSelector((state) => state.user);
  const { manufacturers, categories, subCategories, equipmentSearchData } =
    useAppSelector((state) => state.commonFields);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getReferences = async () => {
    if (
      !manufacturers.length ||
      !categories ||
      !subCategories ||
      !equipmentSearchData
    ) {
      await Promise.all([
        dispatch(fetchCategories()),
        dispatch(fetchSubCategories()),
        dispatch(fetchEquipmentSearchData()),
      ]);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getReferences();
    setIsLoading(false);
  }, []);

  return (
    <>
      <div className='relative'>
        {isLoading && <Loader />}
        <TopNav></TopNav>
        <div className='flex h-[calc(100vh-58px)] lg:h-[calc(100vh-126px)] overflow-y-auto'>
          {userModel && userModel.userLevelId == UserLevelNames.Admin && (
            <SideNav></SideNav>
          )}
          <Outlet></Outlet>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default App;
